module.exports = __webpack_public_path__ + "media/1.b07ea286.mp3";